export default __webpack_public_path__ + "static/media/avatar-felipe-brando.a8a7fb63.svg";